import { useRef, useCallback } from 'react';

/**
 * フロアリストのスクロール機能を提供するカスタムフック
 * @param {Function} handleFixedDisplay - プレースホルダー表示を更新するコールバック
 * @returns {Object} - floorRefs, setFloorRef, scrollToFloor
 */
export const useFloorScrolling = (handleFixedDisplay) => {
  // 各フロアのDOM要素への参照を保持
  const floorRefs = useRef({});

  /**
   * 各フロアボタンにrefを設定するための関数を返す
   * useCallbackで最適化し、不要な再レンダリングを防ぐ
   */
  const setFloorRef = useCallback((floorNumber) => (el) => {
    if (el) {
      // 要素がマウントされたらrefsオブジェクトに追加
      floorRefs.current[floorNumber] = el;
    } else {
      // 要素がアンマウントされたらrefsオブジェクトから削除
      delete floorRefs.current[floorNumber];
    }
  }, []);

  /**
   * 指定したフロアまでスクロールする
   * @param {string} targetFloor - スクロール先のフロア番号
   * @param {boolean} alignToBottom - 画面下部に配置するか（デフォルト: false）
   */
  const scrollToFloor = useCallback((targetFloor, alignToBottom = false) => {
    const targetElement = floorRefs.current[targetFloor];

    if (targetElement) {
      // スクロール実行
      targetElement.scrollIntoView({
        behavior: 'auto',      // スムーズスクロールなし（即座に移動）
        block: alignToBottom ? 'end' : 'start',  // 上部または下部に配置
        inline: 'nearest',     // 横方向は最も近い位置
      });

      // スクロール完了後にプレースホルダー表示を更新
      // 100ms待つことでDOM更新を確実に反映
      setTimeout(handleFixedDisplay, 100);
    }
  }, [handleFixedDisplay]);

  return {
    floorRefs,        // ref管理用オブジェクト
    setFloorRef,      // refを設定する関数
    scrollToFloor     // スクロール実行関数
  };
};